import { render, staticRenderFns } from "./axisInput.vue?vue&type=template&id=2bdea4bc&scoped=true&"
import script from "./axisInput.vue?vue&type=script&lang=ts&setup=true&"
export * from "./axisInput.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./axisInput.vue?vue&type=style&index=0&id=2bdea4bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdea4bc",
  null
  
)

export default component.exports